import { render, staticRenderFns } from "./CompanyPostModal.vue?vue&type=template&id=e880828c"
import script from "./CompanyPostModal.vue?vue&type=script&lang=js"
export * from "./CompanyPostModal.vue?vue&type=script&lang=js"
import style0 from "./CompanyPostModal.vue?vue&type=style&index=0&id=e880828c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports